import { useEffect } from 'react';
import { useSEO, getOrganizationSchema, getWebPageSchema, getServiceSchema, getFAQSchema } from '../../utils/seo';
import Navbar from '../../components/feature/Navbar';
import Hero from './components/Hero';
import PainPoints from './components/PainPoints';
import Solution from './components/Solution';
import HowWeWork from './components/HowWeWork';
import Services from './components/Services';
import CaseStudies from './components/CaseStudies';
import WhyUs from './components/WhyUs';
import Results from './components/Results';
import About from './components/About';
import LeadForm from './components/LeadForm';
import Footer from './components/Footer';

export default function HomePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // SEO Configuration
  const combinedSchema = {
    '@context': 'https://schema.org',
    '@graph': [
      getOrganizationSchema(),
      getWebPageSchema(
        'Systematic Marketing',
        'Системный маркетинг и AI-технологии для стабильного роста продаж. Превращаем хаос в систему. Комплексные решения для масштабирования бизнеса с использованием искусственного интеллекта и сквозной аналитики.',
        'SITE_URL/'
      ),
      getServiceSchema(),
      getFAQSchema()
    ]
  };

  useSEO({
    title: 'Systematic Marketing',
    description: 'Системный маркетинг и AI-технологии для стабильного роста продаж. Превращаем хаос в систему. Комплексные решения для масштабирования бизнеса с использованием искусственного интеллекта и сквозной аналитики.',
    keywords: 'системный маркетинг, AI маркетинг, контекстная реклама, таргетированная реклама, SMM, продвижение на Ozon, маркетинговый консалтинг, сквозная аналитика, ROMI',
    canonical: '/',
    schema: combinedSchema
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <PainPoints />
      <Solution />
      <div id="services">
        <Services />
      </div>
      <div id="how-we-work">
        <HowWeWork />
      </div>
      <div id="cases">
        <CaseStudies />
      </div>
      <Results />
      <div id="why-us">
        <WhyUs />
      </div>
      <div id="about">
        <About />
      </div>
      <div id="team">
        {/* Team section is inside About component */}
      </div>
      <LeadForm />
      <div id="contacts">
        <Footer />
      </div>
    </div>
  );
}
